import types from '../types'
import 'firebase/compat/database'
import getDefaultData from './getDefaultData'
import {getCycleStart} from './getCycleStart'

export const getSummaries = (database) => async (dispatch) => {
  // const dbRef = database.ref('modules/core/summaries')

  // await dbRef.on(
  //     'value',
  //     (snapshot) => {
  //       const val = snapshot.val()
  //       const summaries = val
  //       dispatch({
  //         type: types.STORE_PAYLOAD,
  //         payload: {
  //           summaries,
  //         },
  //       })
  //     },
  //     (errorObject) => console.log(errorObject),
  // )
  const modules = getDefaultData(getCycleStart(1))
  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {
      summaries: modules?.['core']?.['summaries'],
    },
  })
}
